import { PAYMENT_OPTIONS } from 'constants/payment'
import { createSelector } from 'reselect'
import getMerchantFeeAmount from '../getMerchantFeeAmount'
import getDynamicPaymentScheduleDepositAmount from './getDynamicPaymentScheduleDepositAmount'

const getDynamicPaymentScheduleDueToday = createSelector(
  getDynamicPaymentScheduleDepositAmount,
  (state: App.State) => getMerchantFeeAmount(state, PAYMENT_OPTIONS.DYNAMIC_PAYMENT_SCHEDULE),
  (depositAmount, merchantFee): number => {
    if (depositAmount) {
      return depositAmount + merchantFee
    }
    return 0
  },
)

export default getDynamicPaymentScheduleDueToday
